<template>
  <div class="Home">

    <!-- <div class="Home__sub"> -->
        <video class="Home__movie" ref="movie">
            <source src="../assets/movie.webm" type="video/webm">
        </video> 
    <!-- </div> -->

    <div class="Home__block" @click="click()">
        <img v-if="current == 0" class="Home__marker" alt="Vue logo" src="../assets/0.png">
        <img v-if="current == 1" class="Home__marker" alt="Vue logo" src="../assets/1.png">
        <img v-if="current == 2" class="Home__marker" alt="Vue logo" src="../assets/2.png">
        <img v-if="current == 3" class="Home__marker" alt="Vue logo" src="../assets/3.png">
        <img v-if="current == 4" class="Home__marker" alt="Vue logo" src="../assets/4.png">
        <img v-if="current == 5" class="Home__marker" alt="Vue logo" src="../assets/5.png">
        <img v-if="current == 6" class="Home__marker" alt="Vue logo" src="../assets/6.png">
        <img v-if="current == 7" class="Home__marker" alt="Vue logo" src="../assets/7.png">
        <img v-if="current == 8" class="Home__marker" alt="Vue logo" src="../assets/8.png">
        <img v-if="current == 9" class="Home__marker" alt="Vue logo" src="../assets/9.png">
        <img v-if="current == 10" class="Home__marker" alt="Vue logo" src="../assets/10.png">
    </div>

    <!-- <img :src="require('@/assets/sequence_alpha.gif')" /> -->
    <div class="Home__txt">{{ txt }}</div>

  </div>
</template>

<script>

export default {

    name: 'Home',
    data: () => ({
        tempo: 3,
        old: 0,
        current: 0,
        is_playing: false,
        txt: ''
    }),

    mounted() {
    },

    methods: {

        click() { 

            // if(this.is_playing) { 

            //     this.is_playing = !this.is_playing
            //     this.addCountdown()
            //     // this.startMovie()
            // } 
            // else this.resetMovie()

            this.$count = 5
            this.addCountdown()

        },
        addCountdown() {

            console.log('xxxxxx');


            this.$count -= 1
            this.txt = this.$count

            if(this.$count>0) TweenMax.delayedCall(1, this.addCountdown)
            else this.startMovie()



            // this.$countdown = setInterval(()=>{


            //     this.count -= 1
            //     this.txt = this.count

            // }, 1000)


            // setInterval(function() {  

            //     console.log('xxxxx');
    
            //     // if(countdown != 0){
            //     //   $('.timer').text(countdown--); 
            //     //   TweenLite.to("body", 0.5, {backgroundColor:"#FF0000", ease:Power2.easeOut, onComplete: function(){
            //     //     //alert();
            //     //     TweenLite.to("body", 0.5, {backgroundColor:"#000000", ease:Power2.easeOut});
            //     //   }});
            //     // }else {
            //     //   clearInterval(countdown);
            //     // }
                
            // }, 1000)



        },
        startMovie() {

            this.current = 1
            this.addLoop()
            this.$refs.movie.play()
        },
        resetMovie() {

            this.killTweens()
            this.txt = 'reset'
            this.$refs.movie.play()
            this.$refs.movie.currentTime = 0
            this.current = 1
            this.addLoop()
        },
        killTweens() { 

            if(this.$tween) this.$tween.kill()
            if(this.$delay) this.$delay.kill()
        },
        updateCurrent() {

            this.current = (this.old === 10) ? 0 : this.old + 1
            const time = this.current*4
            this.$refs.movie.currentTime = time
            this.txt = String(time)
        },
        addLoop() {   

            this.$tween = TweenMax.delayedCall(this.tempo, ()=>{
                this.old = this.current
                this.current = 0
                this.$delay = TweenMax.delayedCall(1, ()=>{
                    this.updateCurrent()
                    this.addLoop()
                })
            })
        },
    }
}
</script>

<style lang="stylus">

.Home

    cursor pointer
    background-color white
    width 100%
    height 100%
    position absolute
    top 0
    left 0

    &__movie
        overflow hidden
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        background-color white
        width 80%

    &__block
        position absolute
        top 0
        left 0
        background-color white
        width 500px
        height 500px
        cursor pointer
        
    &__marker
        width 100%
        opacity 1

    &__txt
        position absolute
        color black
        font-size 80px
        bottom 0px
        left 24px

            
video 
    width 100%   
    // -webkit-filter grayscale(100%)
    // filter grayscale(100%)  

</style>



























